import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
const Page = lazy(
  () => import("~/features/sub-orders/individual/page-client"),
);
export const Route = createFileRoute(
  "/_authed/agent/sub/orders/individual",
)({
  component: () => (
    <Suspense fallback={null}>
      <Page />
    </Suspense>
  ),
});
